import { registerModal } from '@/store/modalManager/modalManager'
import VerifyPhoneModal from './VerifyPhoneModal.vue'
import AdvertisingModal from './AdvertisingModal.vue'
import GoDepositModal from './GoDepositModal.vue'
import RemoteLoginWarningModal from './RemoteLoginWarningModal.vue'
import KycModal from './KycModal.vue'
import NoAccountTradingModal from './NoAccountTradingModal.vue'
import VerifyTipsModal from './VerifyTipsModal.vue'

export function registerCommonModals() {
  registerModal('VerifyPhoneModal', VerifyPhoneModal)
  registerModal('GoDepositModal', GoDepositModal)
  registerModal('advertising', AdvertisingModal)
  registerModal('RemoteLoginWarningModal', RemoteLoginWarningModal)
  registerModal('KycModal', KycModal)
  registerModal('NoAccountTradingModal', NoAccountTradingModal)
  registerModal('VerifyTipsModal', VerifyTipsModal)
}
